/**
 * Permission Loader Component
 * Automatically loads user permissions after authentication
 */

import { useEffect } from 'react';
import { usePermissionLoader } from '../hooks/usePermissionLoader';

/**
 * Component that automatically loads permissions when user is authenticated
 * Should be placed in the app layout to ensure permissions are loaded
 */
export const PermissionLoader: React.FC = () => {
  usePermissionLoader();

  // The usePermissionLoader hook already handles the automatic loading
  // This component just ensures the hook is active
  useEffect(() => {
    // The hook will automatically load permissions when user becomes authenticated
    // No additional action needed here
  }, []);

  // This component doesn't render anything
  return null;
};

export default PermissionLoader;